function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v6.667H0v-6.667Z",
    style: {
      fill: "#cd1125"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.333h30v6.667H0v-6.667Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.808,16.401h-4.886c-.038.344-.393.597-.793.564-.043-.004-.086-.011-.128-.021.684-.336.641-.677.21-1.434.24-.086.278-.109.52-.273-.172.52.444.457.899.457,0-.182.018-.389-.119-.417.177-.063.192-.083.472-.321v.699h3.371v-.48c0-.056-.045-.101-.101-.101s-.101.045-.101.101v.278c0,.042-.034.076-.076.076h-2.576v-.455l1.934-1.869c-.013.096.187.354.27.396-.063.01-.134-.003-.179.043l-1.583,1.53h1.755c0-.407.379-.407.556-.55.177.144.556.144.556.55v1.227h-.001ZM15.174,16.401v-3.194c.179.098.318.212.54.268-.01.126-.124.167-.124.255v1.965c.247.056.303-.088.422-.162.03.313.23.621.222.869h-1.06ZM18.513,14.268l.391-.328v1.717h.278v-1.952c.136-.114.313-.237.391-.381v3.078h-2.462c-.035-.636-.035-1.29.707-1.149v-.26c0-.061-.091-.013-.091-.068l.508-.424v1.157h.278s0-1.39,0-1.39ZM18.384,13.389c-.048.003-.121-.26-.104-.311.018-.058.083-.058.111-.03.046.043.041.338-.007.341ZM17.927,13.745c-.139-.081-.116-.114.005-.078.21.063.316.01.467-.144l.114.058c.149.076.24.043.293-.139.015-.056.061-.04.073.023.048.253-.144.331-.338.26-.106-.035-.124-.035-.177.005-.117.091-.283.106-.437.015ZM19.939,16.401v-3.194c.179.098.318.212.54.268-.01.126-.124.167-.124.255v1.965c.247.056.303-.088.422-.162.03.313.23.621.222.869h-1.06ZM10.366,16.755c0-.082.067-.149.149-.149s.149.067.149.149-.067.149-.149.149-.149-.067-.149-.149ZM17.591,15.593c0,.047.051.086.114.086s.114-.038.114-.086-.051-.086-.114-.086c-.063,0-.114.039-.114.086Z",
    style: {
      fill: "#017b3d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/IQ.8731e948cd4768fb5c390351ddc1af68.svg";
export { ForwardRef as ReactComponent };